import { ErrorImport, dataImport } from 'components/types/parts/popUp';

function Index({ data, message }: ErrorImport) {
  const matrix = message === 'importBp' || message === 'importOrg';

  return (
    <div className="layoutTableMsg scrollCustom mt-2 !tw-px-[40px] !tw-pt-[0px] !tw-max-h-[525px]">
      <table className="mb-2">
        <thead>
          <tr>
            <th scope="col">Row</th>
            {!matrix && (
            <th scope="col">Column</th>
            )}
            <th scope="col">Message</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((val: dataImport, index: number) => (
            <tr key={index + 1}>
              <th className="thCenter" scope="row">
                {val.row || '-'}
              </th>
              {!matrix && (
              <td>{val.column || '-'}</td>
              )}
              <td>{val.message || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Index;
